import { Expression } from '../Expression.js';
export class LiteralExpression extends Expression {
    constructor(value) {
        super();
        this.value = this.parseValue(value);
    }
    getValue() {
        return this.value;
    }
    evaluate(visitor) {
        return this.getValue();
    }
}
//# sourceMappingURL=LiteralExpression.js.map